import { useState } from 'react';
import {
  CONFIG_ADDITIONAL_ACTION_ID,
  TProductConfigResponse,
  CONFIG_STATUS_ID
} from '../../../../types/product.configuration.types';
import { getConfigurationDisplayElementsBord } from '../../../../utils/logisticServices.utils';
import ConfigurationCommentsModal from 'components/NudosComponents/ConfigurationCommentsModal/ConfigurationCommentsModal';
import { statusVariants } from 'components/NudosComponents/BordStatus/BordStatus.type';
import { renderVariantServicesStatus } from 'constants/constants';
import PendingActionStatus from './PendingActionStatus/PendingActionStatus';
import BordTooltip from 'components/BordTooltip/BordTooltip';
import BordOneToneIcon from 'components/NudosComponents/BordOneToneIcon/BordOneToneIcon';
import { markConfigurationNotCompletedAlertViewed } from 'services/product-configuration.service';
import { displayErrorNotification } from 'utils/displayNudosStandardNotifications';
import BordStatus from 'components/NudosComponents/BordStatus/BordStatus';
import { getAdditionalAction, getCommentsFromEvidence } from 'utils/configurations';

import './NudosConfigurationStatus.scss';

const NudosConfigurationStatus = ({
  configurationData,
  callToActionCallback,
  isAdditionalSettingsInOrders
}: {
  configurationData: TProductConfigResponse;
  callToActionCallback?: () => void;
  isAdditionalSettingsInOrders?: boolean;
}) => {
  const [showConfigurationCommentsModal, setShowConfigurationCommentsModal] = useState(false);

  const { uuid: configurationUuid, evidence, data, configClassId, status, additionalActions } = configurationData || {};

  const comments = getCommentsFromEvidence(evidence);

  if (!configurationData) {
    return <div>No hay datos disponibles</div>;
  }

  const { text, icon, status: displayStatus } = getConfigurationDisplayElementsBord(configurationData);
  const enrollmentAction = getAdditionalAction(additionalActions, CONFIG_ADDITIONAL_ACTION_ID.CONFIRM_ENROLLMENT);
  const requiresAdditionalAction = additionalActions?.length > 0;

  const configurationIsToBeCompleted = status?.statusId === CONFIG_STATUS_ID.TO_COMPLETE;
  const configurationWasNotCompleted = status?.statusId === CONFIG_STATUS_ID.NOT_COMPLETED;
  const hasEnrollmentPending = enrollmentAction && enrollmentAction.confirmedAt === null && requiresAdditionalAction;

  const checkConfigurationEvidenceModalIsDisabled = !status || configurationIsToBeCompleted;

  const markEvidenceViewed = async () => {
    if (!configurationUuid || status?.statusViewedByUserId) return;
    try {
      await markConfigurationNotCompletedAlertViewed(configurationUuid);
    } catch (error) {
      displayErrorNotification();
    }
  };

  const handleCheckConfigurationEvidenceModal = () => {
    if (checkConfigurationEvidenceModalIsDisabled) return;
    if (configurationWasNotCompleted) markEvidenceViewed();
    callToActionCallback?.();
  };

  const openConfigurationCommentsModal = () => setShowConfigurationCommentsModal(true);
  const closeConfigurationCommentsModal = () => setShowConfigurationCommentsModal(false);

  return (
    <div className="nudosConfigurationStatus">
      <div className="containerIconServiceName">
        {icon}
        <div className="serviceName">{text}</div>
      </div>
      {!!comments && (
        <div className="commentsSection cursor-pointer" onClick={openConfigurationCommentsModal}>
          <BordTooltip position="bottom" message="Ver configuración">
            <BordOneToneIcon variant="messageCircle" customWidth="12px" />
          </BordTooltip>
        </div>
      )}
      <div className="divider" />
      {hasEnrollmentPending ? (
        <PendingActionStatus
          status={displayStatus}
          actionText="Estado del Enrollment pendiente por confirmar"
          onClick={handleCheckConfigurationEvidenceModal}
        />
      ) : (
        <BordStatus
          variant={
            renderVariantServicesStatus({ variant: displayStatus as string as statusVariants }) as statusVariants
          }
          renderJSX={
            <div className="customBordStatusContainer" onClick={() => handleCheckConfigurationEvidenceModal()}>
              <span>{displayStatus}</span>
            </div>
          }
        />
      )}
      {showConfigurationCommentsModal && comments && (
        <ConfigurationCommentsModal
          closeModalCallback={closeConfigurationCommentsModal}
          comments={comments || ''}
          configData={data}
          configClassId={configClassId}
          isAdditionalSettingsInOrders={isAdditionalSettingsInOrders}
        />
      )}
    </div>
  );
};

export default NudosConfigurationStatus;
